exports.value = "v2.6.0-beta.3";